export const keyLengthBits = 128;
export const keyLength = keyLengthBits / 8;
export const ivLength = 16;
